import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";

const Hero = () => {
  const navigate = useNavigate();
  
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 z-0 bg-black overflow-hidden">
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          style={{
            width: "calc(max(100vw, 177.78vh) * 1.3)",
            height: "calc(max(100vh, 56.25vw) * 1.3)",
          }}
        >
          <video
            className="w-full h-full object-cover"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            poster="/images/hero-video-poster.jpg"
            aria-label="Piktable Video Background"
          >
            <source src="/videos/piktable-hero.webm" type="video/webm" />
            <source src="/videos/piktable-hero.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
      
      {/* Overlay */}
      <div className="absolute inset-0 z-10 bg-black/60" />
      
      <div className="container mx-auto px-4 py-20 relative z-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <h1 className="font-playfair text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
              L'outil de réservation des restaurateurs suisses.
            </h1>
            <p className="text-lg text-white/90 max-w-xl font-semibold">
              L'outil de réservation pensé à Lausanne pour les cafés, bistrots et restaurants de Suisse romande.
            </p>
            <p className="text-xl text-white/80 max-w-xl">
              Il gère tes réservations, tes tables et tes clients. Tout inclus, sans limite, sans commission par couvert.
            </p>
            <p className="text-sm text-white/60 max-w-xl">
              Essaie gratuitement pendant 30 jours, sans engagement.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button size="lg" className="text-base sm:text-lg min-h-[48px] sm:min-h-[52px] bg-white text-primary hover:bg-white/90" onClick={() => navigate("/signup")}>
                Essayer gratuitement
              </Button>
            </div>
            
            <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/80 pt-2">
              <span className="flex items-center gap-1.5">
                <Check className="w-4 h-4 text-green-400" />
                Configuration en 5 min
              </span>
              <span className="flex items-center gap-1.5">
                <Check className="w-4 h-4 text-green-400" />
                30 jours gratuits
              </span>
              <span className="flex items-center gap-1.5">
                <Check className="w-4 h-4 text-green-400" />
                Sans carte bancaire
              </span>
              <span className="flex items-center gap-1.5">
                <Check className="w-4 h-4 text-green-400" />
                Zéro commission
              </span>
            </div>
          </div>
          
          <div className="relative">
            <div className="rounded-2xl shadow-soft border border-white/20 overflow-hidden bg-card hover:shadow-lg transition-shadow">
              <img
                src="/screenshots/dashboard-overview.png"
                alt="Interface Piktable - Vue d'ensemble des réservations et statut des tables"
                className="w-full h-auto"
                width={1920}
                height={749}
                loading="eager"
                {...({ fetchpriority: "high" } as any)}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
